import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorHandlerService } from '@services/error-handler.service';
import { NullToZeroDirective } from './directives/null-to-zero.directive';
import { RangeValidator } from './directives/range-validator.directive';
import { ConfigComponent } from './components/config/config.component';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SidenavContainerComponent } from './components/common/sidenav-container/sidenav-container.component';
import { FieldEditorComponent } from './components/common/field-editor/field-editor.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClickMonitorDirective } from './directives/click-monitor.directive';
import { InRoleDirective } from './directives/in-role.directive';
import { FolderTreeViewComponent } from './components/common/folder-tree-view/folder-tree-view.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ExpandableContainerComponent } from "./components/review/expandable-container/expandable-container.component";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { SafeResourceUrlPipe } from "./pipes/safe-resource-url.pipe";
import { MatExpansionModule } from "@angular/material/expansion";
import { BatesRangeSelectComponent } from './components/discovery/bates-range-select/bates-range-select.component';
import { MatSelectModule } from '@angular/material/select';
import { ManagePasswordRequirementsComponent } from './components/identity/manage-password/manage-password-requirements/manage-password-requirements.component';
import { MatTableModule } from '@angular/material/table';

@NgModule({
	declarations: [
		NullToZeroDirective,
		RangeValidator,
		ConfigComponent,
		SidenavContainerComponent,
		FieldEditorComponent,
		ClickMonitorDirective,
		InRoleDirective,
		FolderTreeViewComponent,
		ExpandableContainerComponent,
		SafeHtmlPipe,
		SafeResourceUrlPipe,
		BatesRangeSelectComponent,
		ManagePasswordRequirementsComponent
	],
	imports: [CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatInputModule,
		MatSlideToggleModule,
		MatFormFieldModule,
		MatSidenavModule,
		MatToolbarModule,
		MatButtonModule,
		MatMenuModule,
		MatCardModule,
		MatIconModule,
		MatTreeModule,
		DragDropModule,
		MatTooltipModule,
		MatProgressBarModule,
		MatExpansionModule,
		MatAutocompleteModule,
		MatTableModule
	],
	providers: [
		ErrorHandlerService
	],
	exports: [
		CommonModule,
		FormsModule,
		NullToZeroDirective,
		RangeValidator,
		ConfigComponent,
		SidenavContainerComponent,
		FieldEditorComponent,
		ClickMonitorDirective,
		InRoleDirective,
		FolderTreeViewComponent,
		ExpandableContainerComponent,
		SafeHtmlPipe,
		SafeResourceUrlPipe,
		MatExpansionModule,
		BatesRangeSelectComponent,
		ManagePasswordRequirementsComponent
	]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule,
			providers: [ErrorHandlerService]
		};
	}
}
